<wl-name-form
  [trackStep]="trackStep"
  [formState]="formState"
  [rendering]="rendering"
  [floatingLabels]="floatingLabels"
></wl-name-form>
